import { CommonModule, registerLocaleData } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit,LOCALE_ID ,   } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DATE_FORMATS, MatNativeDateModule, MAT_DATE_LOCALE ,DateAdapter} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';

import { Subject, takeUntil, map, startWith, Observable, of } from 'rxjs';
import { ClientesService } from 'src/app/services/clientes.service';
import { LocalesService } from 'src/app/services/locales.service';
import { ProgramacionService } from 'src/app/services/programacion.service';
import { TipoServicioService } from 'src/app/services/tipo-servicio.service';
import { VehiculosService } from 'src/app/services/vehiculos.service';
import localeEnGb from '@angular/common/locales/en-GB';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
import { OrdenServicioService } from 'src/app/services/orden-servicio.service';
import { SolicitarVisitaService } from 'src/app/services/solicitar-visita.service';
import { EspecialidadesService } from 'src/app/services/especialidades.service';
import { SeleccionActivosDialogComponent } from '../solicitudes-de-visita/seleccion-activos-dialog/seleccion-activos-dialog.component';
import { TipoSolicitudService } from '@app/pages/mantenedores/tipo-solicitud/tipo-solicitud.service';
import { FacturacionService } from 'src/app/services/facturacion.service';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export enum SolicitudStatus {
  // 1. Estados iniciales y de coordinación
  PENDIENTE = 'pendiente',
  APROBADA = 'aprobada',
  RECHAZADA = 'rechazada',
  PROGRAMADA = 'programada',
  
  // 2. Estados de ejecución en terreno
  EN_SERVICIO = 'en_servicio',
  EN_PROCESO = 'en_proceso',
  
  // 3. Estados de cierre
  FINALIZADA = 'finalizada',
  VALIDADA = 'validada',
  
  // 4. Estados de control y legado (Legacy)
  REABIERTA = 'reabierta',
  ATENDIDA_EN_PROCESO = 'atendida_en_proceso',
  ELIMINADA = 'eliminada'
}

@Component({
  selector: 'app-generar-programacion',
  standalone: true,
  imports: [CommonModule,MatInputModule, FormsModule, ReactiveFormsModule, MatCardModule, MatFormFieldModule, MatSelectModule, MatButtonModule, MatIconModule ,MatDatepickerModule,MatNativeDateModule, MatAutocompleteModule, MatDialogModule, MatChipsModule],
  templateUrl: './generar-programacion.component.html',
  styleUrl: './generar-programacion.component.scss',
  providers: [
    { provide: LOCALE_ID, useValue: 'en-GB' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Configura el idioma para el picker
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT } // Configura los formatos personalizados
  ]
})

export class GenerarProgramacionComponent implements OnInit, OnDestroy {
  programacionForm: FormGroup;
  locales: any[] = [];
  tiposServicio: any[] = [];
  sectores: any[] = [];
  especialidades: any[] = [];
  vehiculos: any[] = [];
  clientes: any[] = [];
  loading = false;
  tecnicos: any[] = [];
  slas: any[] = []; // Almacenar la lista de SLAs/Tipos de Solicitud (CR-202607-0004)
  private destroy$ = new Subject<void>();
  currentUser: any;
  minDate: Date = new Date();
  filteredClientes!: Observable<any[]>;
  filteredLocales!: Observable<any[]>;
  filteredTecnicos1!: Observable<any[]>;
  filteredTecnicos2!: Observable<any[]>;
  filteredTipoServicio: Observable<any[]>;
  filteredEspecialidades: Observable<any[]>;

  // Selección de activos fijos
  activosSeleccionados: number[] = [];
  clienteApplyFixedAsset = false;

  isReadOnly: boolean = false;
  esGruman: boolean = false;

  constructor(
    private localesService: LocalesService,
    private tipoServicioService: TipoServicioService,
    private vehiculosService: VehiculosService,
    private programacionService: ProgramacionService,
    private clientesService: ClientesService,
    private dateAdapter: DateAdapter <Date>,
    private router: Router,
    private usersService: UsersService,
    private ordenServicioService: OrdenServicioService,
    private solicitarVisitaService: SolicitarVisitaService,
    private especialidadesService: EspecialidadesService,
    private tipoSolicitudService: TipoSolicitudService,
    private facturacionService: FacturacionService,
    private dialog: MatDialog
  ) {
    this.getCurrentUser(); 
    this.isReadOnly = this.currentUser?.profile === 'readonly';
    this.esGruman = this.currentUser?.selectedCompany?.nombre === 'GRUMAN';

    this.initForm();
    registerLocaleData(localeEnGb); 
    this.dateAdapter.setLocale('en-GB'); // Establece el idioma como 'en-GB' para formato dd/MM/yyyy
    this.getCurrentUser(); // Obtener el usuario actual
  }

  private initForm(): void {
    // Determinar estado inicial según si el usuario activo pertenece a GRUMAN
    const estadoInicial = this.esGruman ? SolicitudStatus.PROGRAMADA : SolicitudStatus.APROBADA;
    this.programacionForm = new FormGroup({
      clientId: new FormControl('', [Validators.required]),
      localId: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.min(1)]),
      tipoServicioId: new FormControl({ value: '', disabled: true }, [Validators.required]),
      sectorTrabajoId: new FormControl('', [Validators.required]),
      tipoSolicitudId: new FormControl({ value: '', disabled: true }, [Validators.required]), // Registrar control en el FormGroup reactivo (CR-202607-0004)
      especialidadId: new FormControl('', [Validators.required]),
      status: new FormControl(estadoInicial, [Validators.required]),
      fechaVisita: new FormControl('', [Validators.required]),
      ticketGruman: new FormControl(''),
      tecnico_asignado_id: new FormControl('', [Validators.required]),
      tecnico_asignado_id_2: new FormControl(''),
      observaciones: new FormControl('', [Validators.maxLength(500)]),
      tipo_mantenimiento: new FormControl(SolicitudStatus.PROGRAMADA, [Validators.required]),
    });

    //  Si el usuario es GRUMAN y Solo Lectura, no exigimos Especialidad
    if (this.esGruman && this.isReadOnly) {
      const especialidadCtrl = this.programacionForm.get('especialidadId');
      especialidadCtrl?.clearValidators();
      especialidadCtrl?.disable(); // Lo bloqueamos para que el formulario lo ignore
      especialidadCtrl?.updateValueAndValidity();
    }

    // Agregar validación para evitar técnicos duplicados
    this.programacionForm.get('tecnico_asignado_id')?.valueChanges.subscribe((value: any) => {
      const tecnico2Control = this.programacionForm.get('tecnico_asignado_id_2');
      if (value && tecnico2Control?.value === value && tecnico2Control) {
        tecnico2Control.setValue('');
      }
    });

    this.programacionForm.get('tecnico_asignado_id_2')?.valueChanges.subscribe((value: any) => {
      const tecnico1Control = this.programacionForm.get('tecnico_asignado_id');
      if (value && tecnico1Control?.value === value) {
        Swal.fire({
          title: 'Error',
          text: 'Este técnico ya está seleccionado como Técnico principal',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
        this.programacionForm.get('tecnico_asignado_id_2')?.setValue('');
      }
    });

    // Agregar suscripción para el autocompletado de tipo de servicio y especialidad
    this.programacionForm.get('clientId')?.valueChanges.subscribe(() => {
      this.setupTipoServicioAutocomplete();
      // Potentially reset especialidad if it depends on client? Assuming not for now.
    });
  }

  ngOnInit(): void {
    this.loadInitialData();
    this.setupFormSubscriptions();
    this.setupClienteAutocomplete();
    this.setupTipoServicioAutocomplete();
    this.setupEspecialidadAutocomplete();
  }

  private loadInitialData(): void {
    this.loading = true;
    Promise.all([
      this.getTiposServicio(),
      this.getSectores(),
      this.getVehiculos(),
      this.getClientes(),
      this.getLocales(),
      this.getTecnicos(),
      this.loadEspecialidades()
    ]).finally(() => {
      this.loading = false;
    });
  }

  private setupClienteAutocomplete(): void {
    this.filteredClientes = this.programacionForm.get('clientId')!.valueChanges.pipe(
      startWith(''),
      map((value: any) => {
        if (typeof value === 'string') {
          return this.clientes.filter(cliente =>
            cliente.nombre.toLowerCase().includes(value.toLowerCase())
          );
        }
        return this.clientes;
      })
    );
  }

  private setupFormSubscriptions(): void {
    this.programacionForm.get('clientId')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((clienteId: any) => {
        if (clienteId) {
          this.programacionForm.get('localId')?.enable();
          this.programacionForm.get('tipoServicioId')?.enable();
          this.programacionForm.get('tipoSolicitudId')?.enable(); // selección de SLA al elegir cliente (CR-202607-0004)
          this.getLocales();
          this.programacionForm.get('localId')?.reset();
          this.programacionForm.get('tipoServicioId')?.reset();
          this.programacionForm.get('tipoSolicitudId')?.reset();
          this.getTiposServicio();
          this.getTiposSolicitud(clienteId);

          // Verificar flag apply_fixed_asset del cliente
          const cliente = this.clientes.find(c => c.id === clienteId);
          this.clienteApplyFixedAsset = cliente?.apply_fixed_asset || false;
          this.activosSeleccionados = [];
        } else {
          this.programacionForm.get('localId')?.disable();
          this.programacionForm.get('tipoServicioId')?.disable();
          this.programacionForm.get('tipoSolicitudId')?.disable(); // Deshabilitar control si no hay cliente (CR-202607-0004)
          this.locales = [];
          this.tiposServicio = [];
          this.slas = []; // Limpiar arreglo de opciones (CR-202607-0004)
          this.clienteApplyFixedAsset = false;
          this.activosSeleccionados = [];
        }
      });

    // Resetear activos seleccionados al cambiar de local
    this.programacionForm.get('localId')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.activosSeleccionados = [];
      });

    this.setupLocalAutocomplete();

    this.programacionForm.get('tecnico_asignado_id')?.valueChanges.subscribe((value: any) => {
      const tecnico2Control = this.programacionForm.get('tecnico_asignado_id_2');
      if (value && tecnico2Control?.value === value && tecnico2Control) {
        tecnico2Control.setValue('');
      }
    });

    this.programacionForm.get('tecnico_asignado_id_2')?.valueChanges.subscribe((value: any) => {
      const tecnico1Control = this.programacionForm.get('tecnico_asignado_id');
      if (value && tecnico1Control?.value === value) {
        Swal.fire({
          title: 'Error',
          text: 'Este técnico ya está seleccionado como Técnico principal',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
        this.programacionForm.get('tecnico_asignado_id_2')?.setValue('');
      }
    });
  }

  private setupLocalAutocomplete(): void {
    this.filteredLocales = this.programacionForm.get('localId')!.valueChanges.pipe(
      startWith(''),
      map((value: any) => {
        const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
        return this.locales.filter(local =>
          local.nombre_local.toLowerCase().includes(filterValue)
        );
      })
    );
  }

  getLocales(): void {
    const clienteId = this.programacionForm.get('clientId')?.value;
    if (clienteId) {
      this.loading = true;
      this.localesService.getLocalesByClientId(clienteId)
        .pipe(
          takeUntil(this.destroy$),
          map((locales: any[]) => {
            return locales.sort((a: any, b: any) => {
              // Función para extraer números del inicio del string
              const getLeadingNumber = (str: string) => {
                const match = str.match(/^\d+/);
                return match ? parseInt(match[0]) : null;
              };

              const aName = a.nombre_local.toLowerCase();
              const bName = b.nombre_local.toLowerCase();
              
              // Obtener números del inicio si existen
              const aNum = getLeadingNumber(aName);
              const bNum = getLeadingNumber(bName);

              // Si ambos nombres empiezan con números
              if (aNum !== null && bNum !== null) {
                return aNum - bNum;
              }
              
              // Si solo uno empieza con número, el que no tiene número va primero
              if (aNum === null && bNum !== null) return -1;
              if (aNum !== null && bNum === null) return 1;
              
              // Si ninguno empieza con número, ordenar alfabéticamente
              return aName.localeCompare(bName, 'es');
            });
          })
        )
        .subscribe({
          next: (res: any) => {
            this.locales = res;
            this.programacionForm.get('localId')?.enable();
          },
          error: (error: any) => {
            this.showErrorMessage('Error al cargar los locales');
            this.programacionForm.get('localId')?.disable();
          },
          complete: () => {
            this.loading = false;
          }
        });
    } else {
      this.locales = [];
      this.programacionForm.get('localId')?.disable();
    }
  }

  getClientesFromLocalStorage(): void {
    const currentUserString = localStorage.getItem('currentUser');
    let currentUser: any = null;
    if (currentUserString) {
      currentUser = JSON.parse(currentUserString);
      this.clientes = currentUser.companies.filter((cliente: any) => cliente.id !== 5 && cliente.nombre !== 'GRUMAN');
      this.getLocales();
      if (this.clientes.length === 1) {
        const singleClient = this.clientes[0];
        this.programacionForm.get('clientId')?.setValue(singleClient.id);
        this.programacionForm.get('clientId')?.disable();
        this.getLocales();
      }
    }
  }

  getClientes(): void {
    this.clientesService.getClientes()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.clientes = data;
          this.getLocales()
        },
        error: (error: any) => {
          this.showErrorMessage('Error al cargar los clientes');
        }
      });
  } 

  getTiposServicio(): void {
    const clienteId = this.programacionForm.get('clientId')?.value;
    if (clienteId) {
      this.clientesService.getCliente(clienteId)
        .pipe(
          takeUntil(this.destroy$),
          map((data: any) => ({
            ...data,
            tipoServicio: (data.tipoServicio || []).sort((a: any, b: any) => 
              a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase(), 'es')
            )
          }))
        )
        .subscribe({
          next: (data: any) => {
            this.tiposServicio = data.tipoServicio || [];
            // Se elimina la sobreescritura de 'this.slas' para evitar vaciar la data correcta provista por getTiposSolicitud()
            console.log('Tipos de servicio cargados:', this.tiposServicio);
          },
          error: (error: any) => {
            console.error('Error al cargar tipos de servicio:', error);
            this.tiposServicio = [];
          }
        });
    } else {
      this.tiposServicio = [];
    }
  }

  /**
   * Cargar los tipos de solicitud (SLA) consumiendo el endpoint paginado con exportData en true 
   * para obtener la colección completa mapeada para este cliente (CR-202607-0004)
   */
  getTiposSolicitud(clienteId: number): void {
    this.tipoSolicitudService.findAllPaginado(1, 1000, 'id', 'ASC', '', clienteId, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.slas = res.data || [];
        },
        error: (error: any) => {
          console.error('Error al cargar tipos de solicitud (SLA) desde el controlador:', error);
          this.slas = [];
        }
      });
  }

  getSectores(): void {
    this.sectores = [
      { id: 1, nombre: 'Todos' },
      { id: 2, nombre: 'Sala' },
      { id: 3, nombre: 'Trastienda' },
      { id: 4, nombre: 'Baño' },
      { id: 5, nombre: 'Cocina' },
      { id: 6, nombre: 'Muebles de Belleza' },
      { id: 7, nombre: 'Acceso' }
    ];
  }

  getVehiculos(): void {
    this.vehiculosService.getVehiculos()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.vehiculos = res;
        },
        error: (error: any) => {
          this.showErrorMessage('Error al cargar los vehículos');
        }
      });
  }

  private getCurrentUser(): void {
    const userString = localStorage.getItem('currentUser');
    if (userString) {
      this.currentUser = JSON.parse(userString);
    }
  }

  // 🚀 FEAT: CR-202609-0004 - Verificación de preventivo existente antes de generar la programación
  onSubmit(): void {
    if (this.programacionForm.invalid) {
      this.markFormGroupTouched(this.programacionForm);
      this.showErrorMessage('Por favor, complete todos los campos requeridos correctamente');
      return;
    }

    // Validar selección de activos obligatoria para clientes con apply_fixed_asset y servicio preventivo
    if (this.requiereSeleccionActivos() && this.activosSeleccionados.length === 0) {
      this.showErrorMessage('Debe seleccionar al menos un activo fijo para servicios preventivos de este cliente.');
      return;
    }

    const formData = this.programacionForm.value;
    const tipoServicioId = Number(formData.tipoServicioId);
    const localId = Number(formData.localId);

    // Si es Mantenimiento Preventivo (ID 3), verificamos si ya existe uno para el local
    if (tipoServicioId === 3 && localId) {
      const localSeleccionado = this.locales.find(l => l.id === localId);
      const nombreLocal = localSeleccionado ? localSeleccionado.nombre_local : '';

      this.solicitarVisitaService.verificarPreventivoExistente(localId).subscribe({
        next: (res: any) => {
          if (res && res.existe) {
            Swal.fire({
              title: 'Advertencia',
              text: `ya existe un servicio preventivo para el local ${nombreLocal}, esta seguro de continuar con esta acción`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Sí, continuar',
              cancelButtonText: 'Cancelar',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33'
            }).then((result: any) => {
              if (result.isConfirmed) {
                this.procederCrearProgramacion();
              }
            });
          } else {
            this.confirmarYCrearProgramacion();
          }
        },
        error: () => {
          this.confirmarYCrearProgramacion();
        }
      });
    } else {
      this.confirmarYCrearProgramacion();
    }
  }

  private confirmarYCrearProgramacion(): void {
    Swal.fire({
    title: '¿Estás seguro?',
    text: '¿Quieres crear la programación?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Crear',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33'
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.procederCrearProgramacion();
      }
    });
  }

  private procederCrearProgramacion(): void {
    this.loading = true;
    const formData = this.programacionForm.value;

    // Verificar específicamente localId
    if (formData.localId === null || formData.localId === '' || typeof formData.localId !== 'number' || formData.localId < 1) {
        this.showErrorMessage('El local seleccionado no es válido o no quedó bien seleccionado.');
        this.loading = false;
        return;
    }

    // [CR-202608-0037] Normalización de fechaVisita a formato neutro YYYY-MM-DD
    let fechaVisitaFormateada = formData.fechaVisita;
    if (formData.fechaVisita instanceof Date) {
      const year = formData.fechaVisita.getFullYear();
      const month = String(formData.fechaVisita.getMonth() + 1).padStart(2, '0');
      const day = String(formData.fechaVisita.getDate()).padStart(2, '0');
      fechaVisitaFormateada = `${year}-${month}-${day}`;
    }

    // Garantizar que el estado enviado al servicio sea 'programada' si es GRUMAN
    const estadoFinal = this.esGruman ? SolicitudStatus.PROGRAMADA : SolicitudStatus.APROBADA;

    // CR-202609-0026 Obtener la facturación abierta correspondiente a la fecha de visita
    this.facturacionService.obtenerFacturacionAbierta(formData.clientId, fechaVisitaFormateada).subscribe({
      next: (facturacion: any) => {
        // Conversión segura del técnico 2 a número o null para prevenir errores de base de datos
        const rawTec2Gen = formData.tecnico_asignado_id_2;
        const programacionData = {
          ...formData,
          status: estadoFinal,
          fechaVisita: formData.fechaVisita ? new Date(formData.fechaVisita).toISOString() : null,
          ticketGruman: formData.ticketGruman ? formData.ticketGruman : null,
          tecnico_asignado_id: formData.tecnico_asignado_id ? Number(formData.tecnico_asignado_id) : null,
          tecnico_asignado_id_2: (rawTec2Gen !== null && rawTec2Gen !== '' && rawTec2Gen !== undefined) ? Number(rawTec2Gen) : null,
          observaciones: formData.observaciones ? formData.observaciones : null,
          userId: this.currentUser?.id ? Number(this.currentUser.id) : null,
          aprobada_por_id: this.currentUser?.id ? Number(this.currentUser.id) : null,
          generada_por_id: this.currentUser?.id ? Number(this.currentUser.id) : null,
          facturacion_id: facturacion ? facturacion.id_facturacion : null,
          ...(this.activosSeleccionados.length > 0 && { activoIds: this.activosSeleccionados })
        };

        this.solicitarVisitaService.crearSolicitudVisita(programacionData)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            console.log('Solicitud de visita creada:', res);
            //  Informar al usuario el mes de facturación asignado
            const mesAsignado = facturacion ? facturacion.mes : 'Periodo no determinado';
            Swal.fire({
              title: 'Éxito',
              html: `
                <div style="text-align: left">
                  <p><strong>Solicitud de visita generada correctamente</strong></p>
                  <p><strong>N° Requerimiento:</strong> ${res.data.id}</p>
                  <p><strong>Periodo de Facturación:</strong> ${mesAsignado}</p>
                  <p><strong>Fecha de creación:</strong> ${this.formatDate(new Date().toISOString())}</p>
                </div>
              `,
              icon: 'success'
            });
            this.router.navigate(['/transacciones/listado-programacion']);
          },
          error: (error: any) => {
            console.error('Error al crear la solicitud de visita:', error);
            const errorMsg = error.error?.message || 'El cliente ya tiene una solicitud de visita programada en este mes';
            this.showErrorMessage(errorMsg);
            this.loading = false;
          },
          complete: () => {
            this.loading = false;
          }
        });
      },
      error: (err: any) => {
        console.error('Error al obtener la facturación abierta:', err);
        this.showErrorMessage('Error al verificar el periodo de facturación activo.');
        this.loading = false;
      }
    });
  }

  formatDate(date: string) {
    return new Date(date).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private showSuccessMessage(message: string): void {
    Swal.fire({
      icon: 'success',
      title: '¡Éxito!',
      text: message,
      timer: 2000,
      showConfirmButton: false
    });
  }

  private showErrorMessage(message: string): void {
    Swal.fire({
      icon: 'error',
      title: '¡Error!',
      text: message
    });
  }

  getErrorMessage(field: string): string {
    const control = this.programacionForm.get(field);
    if (control?.hasError('required')) {
      return 'Este campo es requerido';
    }
    if (control?.hasError('maxlength')) {
      return 'El texto es demasiado largo';
    }
    return '';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  volver(){
    this.router.navigate(['/transacciones/listado-programacion']);
  }

  getTecnicos(): void {
    this.usersService.getAllTecnicos()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.tecnicos = res;
      });
  }

  getTecnicosDisponiblesParaSegundoSelect(): any[] {
    const tecnico1Id = this.programacionForm.get('tecnico_asignado_id')?.value;
    return this.tecnicos.filter(tecnico => tecnico.id !== tecnico1Id);
  }

  onClienteFocus() {
    this.filteredClientes = new Observable((observer: any) => {
      observer.next(this.clientes);
    });
  }

  filtrarClientes(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredClientes = new Observable((observer: any) => {
      observer.next(this.clientes.filter(cliente => 
        cliente.nombre.toLowerCase().includes(filterValue)
      ));
    });
  }

  displayFn = (clientId: number): string => {
    const cliente = this.clientes.find(c => c.id === clientId);
    return cliente ? cliente.nombre : '';
  }

  onLocalFocus() {
    this.filteredLocales = new Observable((observer: any) => {
      observer.next(this.locales);
    });
  }

  filtrarLocales(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredLocales = new Observable((observer: any) => {
      observer.next(this.locales.filter(local => 
        local.nombre_local.toLowerCase().includes(filterValue)
      ));
    });
  }

  displayLocalFn = (localId: number): string => {
    const local = this.locales.find(l => l.id === localId);
    return local ? local.nombre_local : '';
  }

  onTecnico1Focus() {
    this.filteredTecnicos1 = new Observable((observer: any) => {
      observer.next(this.tecnicos);
    });
  }

  onTecnico2Focus() {
    const tecnico1Id = this.programacionForm.get('tecnico_asignado_id')?.value;
    this.filteredTecnicos2 = new Observable((observer: any) => {
      observer.next(this.tecnicos.filter(t => t.id !== tecnico1Id));
    });
  }

  filtrarTecnicos1(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredTecnicos1 = new Observable((observer: any) => {
      observer.next(this.tecnicos.filter(tecnico => 
        `${tecnico.name} ${tecnico.lastName}`.toLowerCase().includes(filterValue)
      ));
    });
  }

  filtrarTecnicos2(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    const tecnico1Id = this.programacionForm.get('tecnico_asignado_id')?.value;
    this.filteredTecnicos2 = new Observable((observer: any) => {
      observer.next(this.tecnicos.filter(tecnico => 
        tecnico.id !== tecnico1Id && 
        `${tecnico.name} ${tecnico.lastName}`.toLowerCase().includes(filterValue)
      ));
    });
  }

  displayTecnicoFn = (tecnicoId: number): string => {
    const tecnico = this.tecnicos.find(t => t.id === tecnicoId);
    return tecnico ? `${tecnico.name} ${tecnico.lastName}` : '';
  }

  setupTipoServicioAutocomplete() {
    const tipoServicioControl = this.programacionForm.get('tipoServicioId');
    if (tipoServicioControl) {
      this.filteredTipoServicio = tipoServicioControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => {
          const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
          return this.tiposServicio.filter(tipo => 
            tipo.nombre.toLowerCase().includes(filterValue)
          );
        })
      );
    }
  }

  private _filterTipoServicio(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.tiposServicio.filter(tipo => 
      tipo.nombre.toLowerCase().includes(filterValue)
    );
  }

  onTipoServicioFocus() {
    this.filteredTipoServicio = of(this.tiposServicio);
  }

  displayTipoServicioFn = (tipoId: number): string => {
    if (!tipoId) return '';
    const tipo = this.tiposServicio.find(t => t.id === tipoId);
    return tipo ? tipo.nombre : '';
  }

  filtrarTipoServicio(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredTipoServicio = of(this.tiposServicio.filter(tipo => 
      tipo.nombre.toLowerCase().includes(filterValue)
    ));
  }

  loadEspecialidades(): void {
    this.especialidadesService.findAll()
      .pipe(
        map((especialidades: any[]) => 
          especialidades.sort((a, b) => 
            a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase(), 'es')
          )
        )
      )
      .subscribe({
        next: (data: any[]) => {
          this.especialidades = data;
          console.log('Especialidades cargadas:', this.especialidades);
        },
        error: (error: any) => {
          console.error('Error cargando especialidades:', error);
          this.showErrorMessage('Error al cargar las especialidades');
        }
      });
  }

  setupEspecialidadAutocomplete() {
    const especialidadControl = this.programacionForm.get('especialidadId');
    if (especialidadControl) {
      this.filteredEspecialidades = especialidadControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => {
          const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
          return this._filterEspecialidades(filterValue);
        })
      );
    }
  }

  private _filterEspecialidades(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.especialidades.filter(esp =>
      esp.nombre.toLowerCase().includes(filterValue)
    );
  }

  onEspecialidadFocus() {
    this.filteredEspecialidades = of(this.especialidades);
  }

  displayEspecialidadFn = (especialidadId: number): string => {
    if (!especialidadId) return '';
    const especialidad = this.especialidades.find(e => e.id === especialidadId);
    return especialidad ? especialidad.nombre : '';
  }

  filtrarEspecialidades(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredEspecialidades = of(this._filterEspecialidades(filterValue));
  }

  // --- Selección de activos fijos ---

  requiereSeleccionActivos(): boolean {
    const tipoServicioId = this.programacionForm.get('tipoServicioId')?.value;
    return this.clienteApplyFixedAsset && tipoServicioId === 3;
  }

  puedeSeleccionarActivos(): boolean {
    const localId = this.programacionForm.get('localId')?.value;
    return this.requiereSeleccionActivos() && !!localId && typeof localId === 'number';
  }

  abrirSelectorActivos(): void {
    const localId = this.programacionForm.get('localId')?.value;
    if (!localId) return;

    const dialogRef = this.dialog.open(SeleccionActivosDialogComponent, {
      width: '800px',
      maxHeight: '80vh',
      data: {
        localId: localId,
        preSelectedIds: this.activosSeleccionados,
      },
    });

    dialogRef.afterClosed().subscribe((selectedIds: number[] | undefined) => {
      if (selectedIds !== undefined) {
        this.activosSeleccionados = selectedIds;
      }
    });
  }
}